import { c as _c } from "react/compiler-runtime";
import type { GetOrginizerAvailabilityForMonthByEmailOutputDTO } from '@algoacademy/backend/modules/phone-call-booking/endpoints/queries/get-orginizer-availability-by-email/output.dto';
import { format, getDay, getMonth, getYear, isEqual } from 'date-fns';
import { useEffect } from 'react';
import type { CalendarEvent } from '@/app/(marketing-site)/bezplatna-konsultacja/_components/CalendarEvent';
import { WEEK_DAYS } from '../_components/HourSelector';
type SelectedEventsByWeekDay = Record<WEEK_DAYS, string[]>;
type UseLoadOrganizerAvailabilityProps = {
  organizerAvailabilityData: GetOrginizerAvailabilityForMonthByEmailOutputDTO | undefined;
  setSelectedHoursByDay: (hours: SelectedEventsByWeekDay) => void;
  setSelectedEventsMap: (map: Map<string, CalendarEvent[]>) => void;
};
export function useLoadOrganizerAvailability(t0) {
  const $ = _c(5);
  const {
    organizerAvailabilityData,
    setSelectedHoursByDay,
    setSelectedEventsMap
  } = t0;
  let t1;
  let t2;
  if ($[0] !== organizerAvailabilityData || $[1] !== setSelectedEventsMap || $[2] !== setSelectedHoursByDay) {
    t1 = () => {
      if (!organizerAvailabilityData) {
        return;
      }
      const events = organizerAvailabilityData.events;
      const days = Object.values(WEEK_DAYS);
      const today = new Date();
      const currentMonth = getMonth(today);
      const currentYear = getYear(today);
      const hoursMap = new Map(days.map(_temp));
      for (const event of events) {
        if (!event.isRecurring) {
          continue;
        }
        const eventMonth = getMonth(event.startTime);
        const eventYear = getYear(event.startTime);
        if (eventMonth !== currentMonth || eventYear !== currentYear) {
          continue;
        }
        const dayIndex = getDay(event.startTime);
        const day_0 = days[dayIndex === 0 ? 6 : dayIndex - 1];
        hoursMap.get(day_0)?.add(format(event.startTime, "HH:mm"));
      }
      const selectedHours = Object.fromEntries(days.map(day_1 => [day_1, [...(hoursMap.get(day_1) ?? [])].sort()])) as SelectedEventsByWeekDay;
      setSelectedHoursByDay(selectedHours);
      const eventsMap = new Map();
      for (const event_0 of events) {
        const formattedEvent = format(event_0.startTime, "yyyy.MM.dd");
        const existingEvents = eventsMap.get(formattedEvent) ?? [];
        if (!existingEvents.some(e => isEqual(e.startTime, event_0.startTime))) {
          eventsMap.set(formattedEvent, [...existingEvents, {
            id: event_0.id,
            startTime: event_0.startTime,
            isBooked: event_0.isBooked,
            isRecurring: event_0.isRecurring
          }]);
        }
      }
      setSelectedEventsMap(eventsMap);
    };
    t2 = [organizerAvailabilityData, setSelectedHoursByDay, setSelectedEventsMap];
    $[0] = organizerAvailabilityData;
    $[1] = setSelectedEventsMap;
    $[2] = setSelectedHoursByDay;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
}
function _temp(day) {
  return [day, new Set()];
}